import Vue from "vue";
import { AclInstaller, AclCreate, AclRule } from "vue-acl";
import router from "@/router";

Vue.use(AclInstaller);

let initialRole = "user";

const userInfo = JSON.parse(localStorage.getItem("userInfo"));
//console.log(userInfo);
if (userInfo && userInfo.userRole) initialRole = userInfo.userRole;

//console.log("ACL file");
console.log(initialRole);

function test() {
  console.log("Dela");
};

// ENABLE RULES - ADMIN - EDITOR - USER - NONE
export default new AclCreate({
  initial: initialRole,
  notfound: "/pages/not-authorized",
  router,
  acceptLocalRules: false, // true - to enable rules
  globalRules: {
    admin: new AclRule("admin").generate(),
    editor: new AclRule("editor").or("admin").generate(),
    user: new AclRule("user").or("editor").or("admin").generate()
  }
});